import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

// Autocomplete
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { filter, map, startWith } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Editor , Toolbar} from 'ngx-editor';
import Swal from 'sweetalert2';

import { KnowledgeBaseModalComponent, Article } from './knowledge-base-modal/knowledge-base-modal.component';
import { TicketAssociatedModalComponent } from './ticket-associated-modal/ticket-associated-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewClientModalComponent } from './new-client-modal/new-client-modal.component';

import { Subject } from 'rxjs';

import { TabService } from './../../../tab.service';
import { ViewEncapsulation } from '@angular/core'
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-edit-ticket',
  templateUrl: './edit-ticket.component.html',
  styleUrl: './edit-ticket.component.scss',
  encapsulation: ViewEncapsulation.None, //para que o angular adcione o css ao texto inserido em [innerHTML],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        height: '*',
        opacity: 1,
        overflow: 'hidden'
      })),
      state('out', style({
        height: '0',
        opacity: 0,
        overflow: 'hidden'
      })),
      transition('out => in', [
        style({ height: '0', opacity: 0 }), // Estado inicial
        animate('300ms ease-in-out', style({ height: '*', opacity: 1 }))
      ]),
      transition('in => out', [
        animate('300ms ease-in-out', style({ height: '0', opacity: 0 }))
      ])
    ])
  ]
})
export class EditTicketComponent implements OnInit{

  editor: Editor = new Editor();

  toolbar: Toolbar = [
    ['bold', 'italic', 'underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'], // 🔥 Correção para as listas
    ['undo', 'redo'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['horizontal_rule', 'format_clear'],
  ];

  colorPresets = [
    '#FF0000', '#00FF00', '#0000FF', '#FFFF00', '#FF00FF', '#00FFFF', '#FFFFFF',
    '#C0C0C0', '#808080', '#000000', '#800000', '#808000', '#008000', '#800080',
    '#008080', '#000080', '#FFA500', '#A52A2A', '#DEB887', '#5F9EA0', '#7FFF00'
  ]; // 🔥 Mais cores adicionadas

  html = '';

  public show: boolean = true;
  public realDeskForm!: FormGroup;
  public isLoading:boolean = false;
  public isLoadingOnOpen:boolean = false;
  public isShow2 : Boolean = false;
  public isShowAcoes : Boolean = false;
  public showDivAcoes: Boolean = true;
  public selectedFile: File | null = null;
  public isChat : Boolean = false;
  public isWhatsApp : Boolean = false;
  public ticketId: any;
  public chats: any[] = [];
  public allGroupChats: any [] = [];
  public ticketNovo : Boolean = true;
  public aplicativo: string = '';
  public assunto: string = '';
  public canLeaveChat: boolean = true;

  public verAtendimentosPublicos : Boolean = true;
  public verAtendimentosPrivados : Boolean = true;
  public logadoIsResponsavel: boolean = false;
  public whatsAppEmAtendimento: boolean = false;
  public ticketsRelacionadosJaPesquisado: boolean = false;
  private tabId: string | null = null;

  response: any[] = [];

  clientesEscolhidos: any[] = [];
  operadoresConvidados: any[] = [];
  clientesCopiaEscolhidos: any[] = [];
  arquivosAnexados: any[] = [];
  tagsEscolhidas: any[] = [];
  ticketRelacionados: any[] = [];

  // Autocomplete
  servicesAutoCompleteControl = new FormControl();
  optionsAutoComplete: string[] = []; // You will fill this array with your API data
  filteredOptions: Observable<{   nome: string; email?: string; telefone?: string  }[]> = of([]);
  solicitateCopiaFilteredOptions: Observable<{  nome: string; email?: string; telefone?: string }[]> = of([]);

  //Status
  Status: any[] = [];
  filteredStatusOptions: Observable<any[]> = of([]);

  //Categorias
  categorias: any[] = [];
  filteredCategoriasOptions: Observable<any[]>= of([]);

  //Urgencias
  urgencias: any[] = [];
  filteredUrgenciasOptions: Observable<any[]>= of([]);

  //Responsaveos
  responsaveis: any[] = [];
  filteredResponsaveisOptions: Observable<any[]>= of([]);

  //Tags
  tags: any[] = [];
  filteredTagsOptions: Observable<any[]>= of([]);

//Macros
macros: any[] = [];
filteredMacrosOptions: Observable<any[]>= of([]);

//Atendimentos

atendimentos: any[] = [];

isLoadingResponsaveis: boolean = true;
public selectedResponsible: any;
public selectedUrgency: any;
public selectedCategory: any;
public autocompleteResponsaveisControl = new FormControl();

// New loading state variables
public isLoadingTags: boolean = true;
public isLoadingUrgencias: boolean = true;
public isLoadingCategorias: boolean = true;

constructor(private fb: FormBuilder,  public router: Router, private route: ActivatedRoute, private http: HttpClient, private toastr: ToastrService, private modal : NgbModal, public  tabService: TabService
) {}

  private destroy$ = new Subject<void>();
  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];

      this.load(id);
      this.ticketId = id;

      
  
      this.realDeskForm = this.fb.group({
          id: id,
          assunto: ["", Validators.required],
          nomeCliente: ["", Validators.required],
          dataAbertura: [""],
          horaAbertura: [""],
          origem: [""],
          idSelectedMacro: [""],
          idCategoria: [""],
          idUrgencia: [""],
          idCliente: [""],
          idStatus: [""],
          idOperadorResponsavel: [""],
          htmlContent: [""],
          autocompleteControl: [''],
          autocompleteSolicitanteCopia: [''],
          autocompleteStatus: [''],
          autocompleteCategorias: [''],
          autocompleteUrgencias: [''],
          autocompleteResponsaveis: [''],
          autocompleteTags: [''],
          autocompleteMacros: [''],
          atendimentos: [[]],
          ticketPublico: [true],
          chatGroupId: [0]
        });
    });
    

    this.editor = new Editor({
      content: '',
      plugins: [],
      nodeViews: {},
      history: true,
      keyboardShortcuts: true,
      inputRules: true,
    });


    //Solicitante
    var control =  this.realDeskForm.get('autocompleteControl');
    if (control) {
      this.filteredOptions = control.valueChanges.pipe(
        filter((value: any) => typeof value === 'string' && value.length > 2), // filter out if length is less than 3
        switchMap(value => this.http.get<{ nome: string }[]>(`${environment.apiUrl}/ticket/edit/clientes?search=${value}`)) // replace with your API URL
      );
    } else {
      this.filteredOptions = of([]);
    }

    //Solicitante Copia CC

    var controlSolicitanteCopia =  this.realDeskForm.get('autocompleteSolicitanteCopia');
    if (controlSolicitanteCopia) {
      this.solicitateCopiaFilteredOptions = controlSolicitanteCopia.valueChanges.pipe(
        filter((value: any) => typeof value === 'string' && value.length > 2), // filter out if length is less than 3
        switchMap(value => this.http.get<{ nome: string; email?: string; telefone?: string }[]>(`${environment.apiUrl}/ticket/edit/clientes?search=${value}`)) // replace with your API URL
      );
    } else {
      this.solicitateCopiaFilteredOptions = of([]);
    }

    //Status


    //Categorias


    //Urgencias
    

    //Responsaveis


    //Tags
    this.loadTags();

    //Macros
    this.loadMacros();


    //Load All ChatGroups
    this.loadChatGroups();

  }

  // make sure to destory the editor
  ngOnDestroy(): void {
    this.editor.destroy();
  }

  load(id: any, isreload = false){

    
    if(id && id > 0) 
    {
      this.isLoadingOnOpen  = true
      this.ticketNovo = false;
      this.http.get<any>(`${environment.apiUrl}/ticket/edit/${id}` ).subscribe(
        (response) => {
          this.response = response;
          this.isLoadingOnOpen = false;
          // Fill up the form with the response
        
          this.realDeskForm.patchValue({
            assunto: response.assunto,
            atendimentos: response.atendimentos,
            nomeCliente: response.nomeCliente,
            origem: response.origem,
            dataAbertura: response.dataAbertura,
            horaAbertura: response.horaAbertura,
            idCategoria: response.idCategoria,
            idUrgencia: response.idUrgencia,
            idCliente: response.idCliente,
            idStatus: response.idStatus,
            idOperadorResponsavel: response.idOperadorResponsavel,
            ticketPublico: response.ticketPublico
          });

          this.atendimentos = response.atendimentos;
          this.chats = response.chats;
          this.aplicativo = response.nomeAplicativo;
          this.assunto = response.chatGroup;
          this.logadoIsResponsavel = response.logadoIsResponsavel;
          this.whatsAppEmAtendimento = response.whatsappEmAtendimento;
          this.canLeaveChat = response.canLeaveChat;
          if(response.idOrigem == 2)
          {
            //console.log('response.idOrigem', response.idOrigem);
            this.isChat = true;
          }
          else if(response.idOrigem == 10 ||
            response.idOrigem == 11)
          {
            this.isWhatsApp = true;
          }
          
          

          if(!isreload){
            this.tagsEscolhidas = [];
            this.clientesEscolhidos=[];
            this.clientesCopiaEscolhidos=[];
            this.operadoresConvidados=[];
            response.tags.forEach((tag: any) => {
              this.tagsEscolhidas.push(tag);
            });
            if (response.clientes && response.clientes.length > 0) {
              this.clientesEscolhidos.push(...response.clientes);
            }

            if (response.clientesCopia && response.clientesCopia.length > 0) {
              console.log('response.clientesCopia', response.clientesCopia)
              this.clientesCopiaEscolhidos.push(...response.clientesCopia);
            }

            if (response.operadoresConvidados && response.operadoresConvidados.length > 0) {
              this.operadoresConvidados.push(...response.operadoresConvidados);
            }
            
            this.loadUrgencias();
            this.loadCategorias();
            this.loadResponsaveis();
            this.loadStatus();
          }
          

        },
        (error) => {
          console.error('Error:', error);
        });

    }
    else
    {
      
      this.ticketNovo = true;
      this.loadUrgencias();
      this.loadCategorias();
      this.loadResponsaveis();
      this.loadStatus();
    }
  }

  setTicketPublico(value: boolean) {
    this.realDeskForm.get('ticketPublico')?.setValue(value);
  }
  toggleTicketsRelacionados() {
    if (!this.ticketsRelacionadosJaPesquisado) {
      this.abrirTicketsRelacionados();
      this.ticketsRelacionadosJaPesquisado = true;
    } else {
      this.ticketsRelacionadosJaPesquisado = false; // Fecha a seção
    }
  }

  abrirTicketsRelacionados(){
    if(this.ticketRelacionados.length == 0)
    {
      const id = this.route.snapshot.paramMap.get('id');
      this.http.get<any>(`${environment.apiUrl}/ticket/edit/${id}/associates` ).subscribe(
        (response) => {
          
          this.ticketRelacionados = response;
        },
        (error) => {
          console.error('Error:', error);
        });
    }
  }

  openTicketRelacionadoModal() {
    const modalRef = this.modal.open(TicketAssociatedModalComponent, { size: 'lg' });
  
    modalRef.result.then((selectedTickets: number[]) => {
      if (selectedTickets && selectedTickets.length > 0) {
        // Aqui você recebe a lista de IdTicket selecionados
        console.log('Tickets selecionados:', selectedTickets);
        this.associateTickets(selectedTickets); // Chama a função para associar os tickets
      }
    }).catch(error => {
      console.error('Modal fechado sem seleção', error);
    });
  }
  
  associateTickets(selectedTickets: number[]) {
    const ticketId = this.route.snapshot.paramMap.get('id');
    const requestObject = {
      associatedTicketIds: selectedTickets
    };
  
    this.isLoading = true;
    this.http.post<any>(`${environment.apiUrl}/ticket/edit/${ticketId}/associate`, selectedTickets).subscribe(
      (response) => {
        this.isLoading = false;
        this.toastr.success('Tickets associados com sucesso!');
        this.ticketRelacionados = [];
        this.abrirTicketsRelacionados(); // Atualiza a lista de tickets relacionados
      },
      (error) => {
        this.isLoading = false;
        this.toastr.error('Erro ao associar tickets');
        console.error('Error:', error);
      }
    );
  }

  removerAssociacao(idTicket: number){

    const id = this.route.snapshot.paramMap.get('id');

        Swal.fire({
          html : '<p>Tem certeza que deseja remover o ticket '+id+' como relacionado? </p>',
          showCancelButton : true,
          confirmButtonText : 'SIM',
          cancelButtonText : 'Não',
          customClass : {
            confirmButton : 'btn btn-primary icon',
            cancelButton : 'btn btn-secondary icon',
          }
        }).then((result) => {
          if (result.isConfirmed) {
    
              this.http.post<any>(`${environment.apiUrl}/ticket/edit/${id}/removeassociation`, {idTicket} ).subscribe(
                (response) => {
                  this.isLoading = false;
                  this.toastr.success('Associacao removida');
                  this.ticketRelacionados = [];
                  this.abrirTicketsRelacionados(); 
                },
                (error) => {
                  this.isLoading = false;
                  console.error('Error:', error);
                });
              }
        });
  }

// #region Solicitante

  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    const selectedOption = event.option.value;
    //console.log(selectedOption)
    if(selectedOption.idCliente != null )
    {
        this.clientesEscolhidos.push(selectedOption);
        //alert(`Selected value: ${JSON.stringify(selectedOption)}`);
        this.toastr.success('Cliente '+selectedOption.nome+' adcionada como solicitante!');
    }
    else{
      this.toastr.error('Nenhum cliente selecionado!');

    }
  }

  displayFn(option: any): string {
    return '';
    //return option && option.nome ? option.nome : '';
  }

  removeFromSelectedClients(option: any)
  {
    this.clientesEscolhidos = this.clientesEscolhidos.filter(item => item !== option);
    //console.log(this.clientesEscolhidos);
    this.toastr.success('Cliente '+option.nome+' removido como solicitante!');
  }

// #endregion Solicitante

// #region Solicitante Copia CC

onSolicitanteCopiaSelected(event: MatAutocompleteSelectedEvent) {
  const selectedOption = event.option.value;
  //console.log(selectedOption)

  if(selectedOption.idCliente != null )
  {
    this.clientesCopiaEscolhidos.push(selectedOption);
    //alert(`Selected value: ${JSON.stringify(selectedOption)}`);
    this.toastr.success('Cópia para cliente '+selectedOption.nome+' adcionada!');
  }
  else{
    this.toastr.error('Nenhum cliente selecionado!');

  }
}



removeFromSelectedClientsCopia(option: any)
{
  this.clientesCopiaEscolhidos = this.clientesCopiaEscolhidos.filter(item => item !== option);
  //console.log(this.clientesCopiaEscolhidos);
  this.toastr.success('Cópia para cliente  '+option.nome+' removida!');
}

// #endregion Solicitante Copia CC

// #region - Status

loadStatus(){
  this.http.get<any>(`${environment.apiUrl}/ticket/edit/status` ).subscribe(
    (response) => {
      this.Status = response;
      //console.log(response);

      const control = this.realDeskForm.get('autocompleteStatus');
      if (control) {
          this.filteredStatusOptions = control.valueChanges.pipe(
            startWith(''),
            map(value => this._filterStatus(value || '')),
          );


          const statusSelecionada = this.realDeskForm.get('idStatus');
          if(statusSelecionada){
              // Encontre o objeto correspondente no array this.categorias
              let correspondingOption = this.Status.find(option => option.id === statusSelecionada.value);
              // Defina o objeto correspondente como o valor do controle do formulário
              if (correspondingOption) {
                control.setValue(correspondingOption);
              } else {
                console.error('No corresponding option found for Status ID:', statusSelecionada.value);
              }
          }
        }
    },
    (error) => {
      console.error('Error:', error);
    });
}

private _filterStatus(value: string): string[] {
  if (typeof value === 'string') {
    const filterValue = value.toLowerCase();
    return this.Status.filter((option: any) => option.name.toLowerCase().includes(filterValue));
  } else {
    // Handle the case where value is not a string
    // For example, return an empty array or the entire list
    return this.Status;
  }
}

displayStatus(option: any): string {
  return option && option.name ? option.name : '';
}


onStatusChanged(event: MatAutocompleteSelectedEvent) {
  const selectedOption = event.option.value;

  //console.log(event)
  if(selectedOption.id != null )
  {
    const id = this.route.snapshot.paramMap.get('id');
    this.isLoading = true;

    var requestObject : any = {
      id: id,
      idStatus: selectedOption.id
    };
         this.http.post<any>(`${environment.apiUrl}/ticket/edit/changeStatus`,  requestObject ).subscribe(
       (response) => {
         //console.log(response);
         this.isLoading = false;
         this.toastr.success('Status alterado para '+selectedOption.name);
         this.load(id, true);
       },
       (error) => {
         this.isLoading = false;
         console.error('Error:', error);
       });

  }
  else{
    this.toastr.error('Nenhum status selecionado!');

  }
}

// #endregion

// #region Categoria

loadCategorias(){
  this.isLoadingCategorias = true;
  this.http.get<any>(`${environment.apiUrl}/ticket/edit/categorias` ).subscribe(
    (response) => {
      this.categorias = response;
      const control = this.realDeskForm.get('autocompleteCategorias');
      if (control) {
          this.filteredCategoriasOptions = control.valueChanges.pipe(
            startWith(''),
            map(value => this._filterCategorias(value || '')),
          );

          const categoriaSelecionada = this.realDeskForm.get('idCategoria');
          if (categoriaSelecionada) {
            
            let correspondingOption = this.categorias.find(option => option.id === categoriaSelecionada.value);
            
            if (correspondingOption) {
            
              this.selectedCategory = correspondingOption;
              control.setValue(correspondingOption);
            }
          }
      }
      this.isLoadingCategorias = false;
      
    },
    (error) => {
      console.error('Error:', error);
      this.isLoadingCategorias = false;
    });
}

private _filterCategorias(value: string): any[] {
  if (typeof value === 'string') {
    const filterValue = value.toLowerCase();
    return this.categorias.filter((option: any) => option.name.toLowerCase().includes(filterValue));
  } else {
    return this.categorias;
  }
}

displayCategorias(option: any): string {
  return option && option.name ? option.name : '';
}
// #endregion Categoria

// #region Urgencia *****/

loadUrgencias(){
  this.isLoadingUrgencias = true;
  this.http.get<any>(`${environment.apiUrl}/ticket/edit/urgencias` ).subscribe(
    (response) => {
      this.urgencias = response;
      this.filteredUrgenciasOptions = of(this.urgencias);

      const control = this.realDeskForm.get('autocompleteUrgencias');
      if (control) {
          this.filteredUrgenciasOptions = control.valueChanges.pipe(
            startWith(''),
            map(value => this._filterUrgencias(value || '')),
          );

          const urgenciaSelecionada = this.realDeskForm.get('idUrgencia');

          if(urgenciaSelecionada){
            
              let correspondingOption = this.urgencias.find(option => option.id === urgenciaSelecionada.value);
              if (correspondingOption) {
                this.selectedUrgency = correspondingOption;
                control.setValue(correspondingOption);
              } 
            }
          }
        this.isLoadingUrgencias = false;
    },
    (error) => {
      console.error('Error:', error);
      this.isLoadingUrgencias = false;
    });
}

private _filterUrgencias(value: string): any[] {
  if (typeof value === 'string') {
    const filterValue = value.toLowerCase();
    return this.urgencias.filter((option: any) => option.name.toLowerCase().includes(filterValue));
  } else {
    return this.urgencias;
  }
}

displayUrgencias(option: any): string {
  return option && option.name ? option.name : '';
}
// #endregion Urgencia *****/

// #region Responsaveis

loadResponsaveis(){
  this.isLoadingResponsaveis = true;
  this.http.get<any>(`${environment.apiUrl}/ticket/edit/responsaveis` ).subscribe(
    (response) => {
      this.responsaveis = response;
      //console.log(response);

      const control = this.realDeskForm.get('autocompleteResponsaveis');
      if (control) {
          this.filteredResponsaveisOptions = control.valueChanges.pipe(
            startWith(''),
            map(value => this._filterResponsaveis(value || '')),
          );

          const responsavelSelecionado = this.realDeskForm.get('idOperadorResponsavel');
          if (responsavelSelecionado) {
            let correspondingOption = this.responsaveis.find(option => option.idUsuario === responsavelSelecionado.value);
            if (correspondingOption) {
              this.selectedResponsible = correspondingOption;
              control.setValue(correspondingOption);
            }
          }
      }
      this.isLoadingResponsaveis = false;
    },
    (error) => {
      console.error('Error:', error);
      this.isLoadingResponsaveis = false;
    });
}

private _filterResponsaveis(value: string): string[] {
  //console.log('value:', value);
  if (typeof value === 'string') {
    const filterValue = value.toLowerCase();
    return this.responsaveis.filter((option: any) => option.nome.toLowerCase().includes(filterValue));
  } else {
    // Handle the case where value is not a string
    // For example, return an empty array or the entire list
    return this.responsaveis;
  }
}

displayResponsaveis(option: any): string {
  return option && option.nome ? option.nome : '';
}

onResponsibleSelected(option: any): void {
  if (option) {
    this.selectedResponsible = option;
    this.realDeskForm.patchValue({
      idOperadorResponsavel: option.idUsuario
    });
    this.toastr.success('Operador ' + option.nome + ' selecionado como responsável!');
  }
}
// #endregion

// #region Tags *****/

loadTags(){
  this.isLoadingTags = true;
  this.http.get<any>(`${environment.apiUrl}/ticket/edit/Tags` ).subscribe(
    (response) => {
      this.tags = response;
      this.filteredTagsOptions = of(this.tags);

      const control = this.realDeskForm.get('autocompleteTags');
      if (control) {
          this.filteredTagsOptions = control.valueChanges.pipe(
            startWith(''),
            map(value => this._filterTags(value || '')),
          );
      }
      this.isLoadingTags = false;
    },
    (error) => {
      console.error('Error:', error);
      this.isLoadingTags = false;
    });
}

private _filterTags(value: string): any[] {
  if (typeof value === 'string' && value != null && value != undefined && value != '') {
    const filterValue = value.toLowerCase();
    return this.tags.filter((option: any) => option.name.toLowerCase().includes(filterValue));
  } else {
    return this.tags;
  }
}

displayTags(option: any): string {
  
  return option && option.name ? option.name : '';
}


addNewTag(event:any): void {
  const inputValue = event.target.value;
  if (inputValue) {

    this.tagsEscolhidas.push({ id: 0, name: inputValue});
    
  }
}


onTagSelected(event: any): void {
  const option = event;
  if (option && option.id) {
    this.tagsEscolhidas.push(option);
    this.toastr.success('Tag ' + option.name + ' adicionada!');
  }
}
removeFromSelectedTags(option: any)
{
  this.tagsEscolhidas = this.tagsEscolhidas.filter(item => item !== option);
  //console.log(this.tagsEscolhidas);
  this.toastr.success('Tag '+option.name+' removida!');
}
// #endregion - Tags *****/

// #region - Macros *****/


  loadMacros(){
    this.http.get<any>(`${environment.apiUrl}/ticket/edit/macros` ).subscribe(
      (response) => {
        //this.macros = response;
        this.macros = response;
        //console.log(response);

        const control = this.realDeskForm.get('autocompleteMacros');
        if (control) {
            this.filteredMacrosOptions = control.valueChanges.pipe(
              startWith(''),
              map(value => this._filterMacros(value || '')),
            );
        }
      },
      (error) => {
        console.error('Error:', error);
      });
  }

  chatMessage: string = "";
  onMacroSelectChange(event: MatAutocompleteSelectedEvent) {
    const selectedOption = event.option.value;
    //console.log(selectedOption)
    if(selectedOption.id != null )
    {
        //alert(`Selected value: ${JSON.stringify(selectedOption)}`);
        this.toastr.success('Macro '+selectedOption.name+' adcionada ao atendimento !');
        this.realDeskForm.patchValue({
          htmlContent: selectedOption.htmlContent
        });

        this.chatMessage= selectedOption.textContent;
    }
    else{
      this.toastr.error('Nenhuma foi selecionado!');
    }
  }

  private _filterMacros(value: string): string[] {

    if (typeof value === 'string' && value != null && value != undefined && value != '') {
      const filterValue = value.toLowerCase();
      return this.macros.filter((option: any) => option.nome.toLowerCase().includes(filterValue));
    } else {
      // Handle the case where value is not a string
      // For example, return an empty array or the entire list
      return this.macros;
    }

  }

  displayMacro(option: any): string {
    return option && option.name ? option.name : '';
  }
// #endregion - Macros *****/


// #region - Anexos *****/
onFileSelected(event: any) {
  this.selectedFile = <File>event.target.files[0];
  this.addAttach();
}

addAttach(){
  this.isLoading = true
  const fd = new FormData();
  if (this.selectedFile) {
    let filesize = this.selectedFile.size / 1024 / 1024;
    fd.append('file', this.selectedFile, this.selectedFile?.name);

        // Anexa o ID ao FormData
    const ticketId = this.route.snapshot.paramMap.get('id');
   // Verifica se ticketId não é nulo ou indefinido
   if (ticketId !== null && ticketId !== undefined) {
          fd.append('id', ticketId.toString()); // Converte o inteiro para string
   } else {
          this.toastr.error('ID do ticket inválido!');
          this.isLoading = false;
          return; // Sai da função se o ID for inválido
  }
    
    //console.log(this.selectedFile);
    this.http.post<any>(`${environment.apiUrl}/ticket/edit/attach`, fd)
      .subscribe(res => {
        this.arquivosAnexados.push(
          {
            name: this.selectedFile?.name,
            link: res,
            size: filesize,
          });
        this.toastr.success('Arquivo adcionado ao atendimento !');
        this.isLoading = false;
      });
    }
}

removeFromAttach(option: any)
{
  this.arquivosAnexados = this.arquivosAnexados.filter(item => item !== option);
  //console.log(this.arquivosAnexados);
  this.toastr.success('Arquivo '+option.name+' removido de anexo!');
}

// #endregion - Anexos *****/

addAttachAlreadyInThisTicket(){
  alert('NAO DESENVOLVIDO 2'	)
}


addKnowledgeBase() {
  const ticketId = this.route.snapshot.paramMap.get('id');
  this.http.post<any>(`${environment.apiUrl}/ticket/edit/ai/${ticketId}`, null)
    .subscribe(res => {
      this.animateTypingEffect(res.resposta);
      this.toastr.success('Arquivo adicionado ao atendimento!');
      this.isLoading = false;
    });
}

animateTypingEffect(fullText: string) {
  let index = 0;
  let displayText = '';
  const typingSpeed = 25; // Velocidade da digitação (ms por caractere)

  const interval = setInterval(() => {
    if (index < fullText.length) {
      displayText += fullText[index];
      this.realDeskForm.patchValue({
        htmlContent: displayText
      });
      index++;
    } else {
      clearInterval(interval);
    }
  }, typingSpeed);
}

// #region - Base de conhecimento *****/

selectedArticle: Article | null = null;


openKnowledgeBase() {
  const modalRef = this.modal.open(KnowledgeBaseModalComponent, { size: 'lg' });

  modalRef.result.then((article: Article) => {
    if (article) {
      this.selectedArticle = article;
      this.realDeskForm.patchValue({
        htmlContent: this.selectedArticle.htmlContent
      });
      console.log('Artigo Selecionado:', article);
    }
  }).catch(error => {
    console.error('Modal fechado sem seleção', error);
  });
}

// #endregion - Base de conhecimento *****/

onVisualizarAcaoPublicaChange(){
  alert(this.verAtendimentosPublicos)
  this.atendimentos = this.atendimentos.filter(atendimento => atendimento.flagPrivado === true);
}



onStatuselectChange(){
  alert('NAO DESENVOLVIDO onStatuselectChange'	)
}



  create() {
    const id = this.route.snapshot.paramMap.get('id');
    this.isLoading = true;

    const htmlContentControl = this.realDeskForm.get('htmlContent');
    if (!htmlContentControl) {
      console.error('htmlContent control not found');
      return;
    }

    const idCategoria = this.realDeskForm.get('autocompleteCategorias');
    if (!idCategoria) {
      console.error('Categoria control not found');
      return;
    }

    const idUrgencia = this.realDeskForm.get('autocompleteUrgencias');
    if (!idUrgencia) {
      console.error('Urgencia control not found');
      return;
    }

    const idResponsavel = this.realDeskForm.get('autocompleteResponsaveis');
    if (!idResponsavel) {
      console.error('Responsavel control not found');
      return;
    }

    const idStatus = this.realDeskForm.get('autocompleteStatus');
    if (!idStatus) {
      console.error('Status control not found');
      return;
    }

    const ticketPublico = this.realDeskForm.get('ticketPublico');
    if (!ticketPublico) {
      console.error('Responsavel control not found');
      return;
    }

    const assuntoTicket = this.realDeskForm.get('assunto');
    if (!assuntoTicket) {
      console.error('Assunto control not found');
      return;
    }

    console.log('this.tagsEscolhidas', this.tagsEscolhidas)

  var requestObject : any = {
    id: id,
    htmlContent: htmlContentControl.value,
    assunto: assuntoTicket.value,
    idCategoria: idCategoria.value.id,
    idUrgencia: idUrgencia.value.id,
    idResponsavel: idResponsavel.value.idUsuario,
    idSolicitantes: this.clientesEscolhidos.map(cliente => cliente.idCliente),
    idSolicitantesCopia: this.clientesCopiaEscolhidos.map(cliente => cliente.idCliente),
    idTags: this.tagsEscolhidas,
    anexos: this.arquivosAnexados.map(anexo => anexo.name),
    idStatus: idStatus.value.id,
    ticketPublico: Boolean(ticketPublico.value)
  };




     this.http.post<any>(`${environment.apiUrl}/ticket/edit/`,  requestObject ).subscribe(
       (response) => {
         //console.log(response);
         this.isLoading = false;
         this.toastr.success('Atendimento realizado com sucesso');

     
         this.load(id, true);
         this.arquivosAnexados = [];
       },
       (error) => {
         this.isLoading = false;
         console.error('Error:', error);
       });
   };


   encerrarChat() {
    const confirmed = confirm('Tem certeza que deseja encerrar o chat?');
  
    if (confirmed) {
      const requestObject: any = {
        ticketId: this.route.snapshot.paramMap.get('id')
      };
  
      this.isLoading = true; // Inicia o carregamento
  
      this.http.post<any>(`${environment.apiUrl}/ticket/chat/close`, requestObject).subscribe(
        (response) => {
          this.isLoading = false;
          this.toastr.success('Chat encerrado com sucesso');
          this.isChat = false;
          this.load(this.route.snapshot.paramMap.get('id'), true);
          this.tabService.closeActiveTab();
        },
        (error) => {
          this.isLoading = false;
          console.error('Error:', error);
        }
      );
    }
  }
  
  leaveChat() {
    const confirmed = confirm('Tem certeza que deseja sair do chat? O seu cliente continuara sendo atendido por outro agente.');
  
    if (confirmed) {
      const requestObject: any = {
        ticketId: this.route.snapshot.paramMap.get('id')
      };
  
      this.isLoading = true; // Inicia o carregamento
  
      this.http.post<any>(`${environment.apiUrl}/ticket/chat/leave`, requestObject).subscribe(
        (response) => {
          this.isLoading = false;
          this.toastr.success('Você saiu do chat!');
          this.isChat = true;
          this.load(this.route.snapshot.paramMap.get('id'), false);
        },
        (error) => {
          this.isLoading = false;
          console.error('Error:', error);
        }
      );
    }
  }

   salvarChat(){

    const id = this.route.snapshot.paramMap.get('id');
    this.isLoading = true;

    const htmlContentControl = this.realDeskForm.get('htmlContent');
    if (!htmlContentControl) {
      console.error('htmlContent control not found');
      return;
    }

    const idCategoria = this.realDeskForm.get('autocompleteCategorias');
    if (!idCategoria) {
      console.error('Categoria control not found');
      return;
    }

    const idUrgencia = this.realDeskForm.get('autocompleteUrgencias');
    if (!idUrgencia) {
      console.error('Urgencia control not found');
      return;
    }

    const idResponsavel = this.realDeskForm.get('autocompleteResponsaveis');
    if (!idResponsavel) {
      console.error('Responsavel control not found');
      return;
    }

    const idStatus = this.realDeskForm.get('autocompleteStatus');
    if (!idStatus) {
      console.error('Status control not found');
      return;
    }

    const ticketPublico = this.realDeskForm.get('ticketPublico');
    if (!ticketPublico) {
      console.error('Responsavel control not found');
      return;
    }

    const assuntoTicket = this.realDeskForm.get('assunto');
    if (!assuntoTicket) {
      console.error('Assunto control not found');
      return;
    }

    console.log('this.tagsEscolhidas', this.tagsEscolhidas)

  var requestObject : any = {
    id: id,
    htmlContent: htmlContentControl.value,
    assunto: assuntoTicket.value,
    idCategoria: idCategoria.value.id,
    idUrgencia: idUrgencia.value.id,
    idResponsavel: idResponsavel.value.idUsuario,
    idSolicitantes: this.clientesEscolhidos.map(cliente => cliente.idCliente),
    idSolicitantesCopia: this.clientesCopiaEscolhidos.map(cliente => cliente.idCliente),
    idTags: this.tagsEscolhidas,
    anexos: this.arquivosAnexados.map(anexo => anexo.name),
    idStatus: idStatus.value.id,
    ticketPublico: Boolean(ticketPublico.value)
  };




     this.http.post<any>(`${environment.apiUrl}/ticket/chat/save`,  requestObject ).subscribe(
       (response) => {
         //console.log(response);
         this.isLoading = false;
         this.toastr.success('Chat atualizado com sucesso');
        //  this.tabService.closeActiveTab();
        //  this.router.navigate(['/tickets', response, 'edit']);
       },
       (error) => {
         this.isLoading = false;
         console.error('Error:', error);
       });

   }

   mofiModal(){

    const modalRef = this.modal.open(NewClientModalComponent);
        modalRef.result.then((data) => {
          //console.log('NewClientModalComponent', data);  // This will log the data passed back from the modal
          if(data != null && data != undefined && data != '')
            this.clientesEscolhidos.push(data);
        }).catch((error) => {
          console.error(error);
        });
  }

//previnir que um enter digitado acione qualquer evento
  onFormKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();  // Impede a ação padrão do Enter
    }
  }


  loadChatGroups(){
    this.http.get<any>(`${environment.apiUrl}/chatgroup/list/` ).subscribe(
      (response) => {
        //this.macros = response;
        this.allGroupChats = response;
        //console.log(response);
      },
      (error) => {
        console.error('Error:', error);
      });
  }

  transferirChatClick() {
  const id = this.route.snapshot.paramMap.get('id');

  const chatGroupId = this.realDeskForm.get('chatGroupId');
    if (!chatGroupId) {
      console.error('chatGroupId control not found');
      return;
    }


  var requestObject : any = {
    ticketId: id,
    chatGroupId:chatGroupId.value,
     };


  this.http.post<any>(`${environment.apiUrl}/ticket/chat/transfer`,  requestObject ).subscribe(
    (response) => {
      //console.log(response);
      this.isLoading = false;
      this.toastr.success('Chat tranferido com sucesso');
      this.router.navigate(['/tickets/chat']);
    },
    (error) => {
      this.isLoading = false;
      console.error('Error:', error);
    });
}

executeTaskEmitChatEncerrado() {
  alert('Atenção, o cliente encerrou o chat');
  this.isChat = false;
  this.load(this.route.snapshot.paramMap.get('id'), true);
}

executeTaskChatInvitation(){
  const id = this.route.snapshot.paramMap.get('id')
  this.http.post<any>(`${environment.apiUrl}/ticket/edit/`+id+`/chatinvitation`,  null ).subscribe(
    (response) => {
      //console.log(response);
      this.isLoading = false;
      this.toastr.success('Convite aceito com sucesso');
      this.load(this.route.snapshot.paramMap.get('id'), false);
    },
    (error) => {
      this.isLoading = false;
      console.error('Error:', error);
    });
}

formatDate(dateString: string): Date {
  if (!dateString) {
    return new Date();
  }

  // Tenta converter a string para data
  const date = new Date(dateString);
  if (!isNaN(date.getTime())) {
    return date;
  }

  // Se for uma string no formato DD/MM/YYYY
  if (dateString.includes('/')) {
    const [day, month, year] = dateString.split('/');
    const date = new Date(Number(year), Number(month) - 1, Number(day));
    if (!isNaN(date.getTime())) {
      return date;
    }
  }

  // Se nada funcionar, retorna a data atual
  return new Date();
}


// Keep only the first implementation of onCategoriaSelected
onCategoriaSelected(event: any): void {
  const option = event;
  if (option && option.id) {
    // Atualiza o controle do autocomplete
    const control = this.realDeskForm.get('autocompleteCategorias');
    if (control) {
      control.setValue(option);
    }
    
    // Atualiza o ID da categoria no formulário
    this.realDeskForm.patchValue({
      idCategoria: option.id
    });

    // Atualiza a categoria selecionada
    this.selectedCategory = option;

    this.toastr.success('Categoria ' + option.name + ' selecionada!');
  }
}

// Keep only the first implementation of onUrgenciaSelected
onUrgenciaSelected(event: any): void {
  const option = event;
  if (option && option.id) {
    // Atualiza o controle do autocomplete
    const control = this.realDeskForm.get('autocompleteUrgencias');
    if (control) {
      control.setValue(option);
    }
    
    // Atualiza o ID da urgência no formulário
    this.realDeskForm.patchValue({
      idUrgencia: option.id
    });

    // Atualiza a urgência selecionada
    this.selectedUrgency = option;

    this.toastr.success('Urgência ' + option.name + ' selecionada!');
  }
}

// Helper method to get form controls safely
getFormControl(controlName: string): FormControl {
  const control = this.realDeskForm.get(controlName);
  if (!control) {
    throw new Error(`Form control ${controlName} not found`);
  }
  return control as FormControl;
}

}



